import { Box } from "@chakra-ui/layout";
import { Switch } from "@chakra-ui/switch";
import { Col, Row } from "antd";
import Filters from "ui/components/Filters";
import Field from "ui/components/Input/Field";

function Filtros() {
  return (
    <>
      <Filters>
        {({control}) => (
          <Box>
            <Row gutter={32}>
              <Col sm={12}>
                <Field
                  rules={{
                    required: true,
                  }}
                  label="Capacidade Máxima"
                  control={control}
                  name="capacidadeMaxima"
                  inputProps={{
                    type: "number",
                    placeholder: "Capacidade Máxima",
                  }}
                />
              </Col>

              <Col sm={12}>
                <Field
                  label="Status"
                  name="ativo"
                  control={control}
                  render={({ field }) => (
                    <Switch
                      mt="14px"
                      onChange={() => {
                        field.onChange(!field.value);
                      }}
                      isChecked={!!field.value}
                    >
                      Ativo
                    </Switch>
                  )}
                />
              </Col>
            </Row>
          </Box>
        )}
      </Filters>
    </>
  );
}

export default Filtros;
